"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OwnerType = void 0;

/**
 * All owner types available for iOS (screen) and web (page)
 *
 * @packageDocumentation
 */
let OwnerType;
/**
 * Owner types available in iOS
 */

exports.OwnerType = OwnerType;

(function (OwnerType) {
  OwnerType["allArtistSeries"] = "allArtistSeries";
  OwnerType["article"] = "article";
  OwnerType["articles"] = "articles";
  OwnerType["artist"] = "artist";
  OwnerType["artists"] = "artists";
  OwnerType["artistSeries"] = "artistSeries";
  OwnerType["artwork"] = "artwork";
  OwnerType["auctions"] = "auctions";
  OwnerType["gene"] = "gene";
  OwnerType["cityGuideGuide"] = "cityGuideGuide";
  OwnerType["cityGuideMap"] = "cityGuideMap";
  OwnerType["cityPicker"] = "cityPicker";
  OwnerType["collect"] = "collect";
  OwnerType["collection"] = "collection";
  OwnerType["collections"] = "collections";
  OwnerType["consignmentSubmission"] = "consignmentSubmission";
  OwnerType["consign"] = "consign";
  OwnerType["explore"] = "explore";
  OwnerType["fair"] = "fair";
  OwnerType["fairArtworks"] = "fairArtworks";
  OwnerType["fairs"] = "fairs";
  OwnerType["galleries"] = "galleries";
  OwnerType["home"] = "home";
  OwnerType["inbox"] = "inbox";
  OwnerType["partner"] = "partner";
  OwnerType["profile"] = "profile";
  OwnerType["sale"] = "sale";
  OwnerType["saleInformation"] = "saleInformation";
  OwnerType["search"] = "search";
  OwnerType["sell"] = "sell";
  OwnerType["show"] = "show";
  OwnerType["savesAndFollows"] = "savesAndFollows";
  OwnerType["viewingRoom"] = "viewingRoom";
  OwnerType["viewingRooms"] = "viewingRooms";
  OwnerType["viewingRoomArtworks"] = "viewingRoomArtworks";
  OwnerType["viewingRoomList"] = "viewingRoomList";
  OwnerType["viewingRoomArtworkPage"] = "viewingRoomArtworkPage";
  OwnerType["worksForYou"] = "worksForYou";
})(OwnerType || (exports.OwnerType = OwnerType = {}));